import React from 'react'
import styles from './TopBar.module.css'
import Logo from '../ui/logo'
import { AuthBar } from '../features/auth'
//import Button from '../ui/button'
//import { MenuIcon } from '../ui/icon'


export default function TopBar() {
    return (
        <div className={styles.root}>
            {/* 
            <div className={styles.menu}>
                <Button icon={MenuIcon} onClick={() => alert("open menu")} />
            </div>
             */}
            <Logo className={styles.logo} />
            <div className={styles.user}>
                <AuthBar />
            </div>
        </div>
    )
}